import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoadingComponent } from './loading.component';
import { FlexLayoutModule } from '@angular/flex-layout';
import { EffectsModule } from '@ngrx/effects';
import { LoadingEffects } from './loading.effects';

@NgModule({
  declarations: [LoadingComponent],
  imports: [
    CommonModule,
    FlexLayoutModule,
    EffectsModule.forFeature([LoadingEffects])
  ],
  exports: [LoadingComponent]
})
export class DxLoadingModule {}
